import BMF from 'browser-md5-file'

export default file =>
  new Promise((resolve, reject) => {
    new BMF().md5(file, (err, md5) => (err ? reject(err) : resolve(md5)))
  })
